'use client';

import { c as _c } from "react/compiler-runtime";
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';
import { cn } from '@/lib/styles';
interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  labelLeft?: string;
  labelRight?: string;
}
const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>((t0, ref) => {
  const $ = _c(22);
  let className;
  let labelLeft;
  let labelRight;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      labelLeft,
      labelRight,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = labelLeft;
    $[3] = labelRight;
    $[4] = props;
  } else {
    className = $[1];
    labelLeft = $[2];
    labelRight = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== labelLeft || $[6] !== props) {
    t1 = labelLeft && <span className={cn("text-xl leading-15 text-neutral-dark-600", !props.checked && "font-bold text-brand-black")}>{labelLeft}</span>;
    $[5] = labelLeft;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== className) {
    t2 = cn("peer inline-flex h-9 w-18 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent  transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-black data-[state=unchecked]:bg-neutral-light-500 outline-none ", className);
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SwitchPrimitives.Thumb className="pointer-events-none block size-5.5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-10.5 data-[state=unchecked]:translate-x-1.5" />;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props || $[12] !== ref || $[13] !== t2) {
    t4 = <SwitchPrimitives.Root className={t2} {...props} ref={ref}>{t3}</SwitchPrimitives.Root>;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== labelRight || $[16] !== props) {
    t5 = labelRight && <span className={cn("text-xl leading-15 text-neutral-dark-600", props.checked && "font-bold text-brand-black")}>{labelRight}</span>;
    $[15] = labelRight;
    $[16] = props;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t5) {
    t6 = <div className="flex items-center space-x-2">{t1}{t4}{t5}</div>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
});
Switch.displayName = SwitchPrimitives.Root.displayName;
export { Switch };